import { render, staticRenderFns } from "./PublishedLimits.vue?vue&type=template&id=726a01da&scoped=true&"
import script from "./PublishedLimits.vue?vue&type=script&lang=js&"
export * from "./PublishedLimits.vue?vue&type=script&lang=js&"
import style0 from "./PublishedLimits.vue?vue&type=style&index=0&id=726a01da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726a01da",
  null
  
)

export default component.exports